
export enum SubPlantCodesEnum {
    KDM = 'KADIYAM',
    MTM = 'MACHILIPATNAM',
    BVRM = 'BHIMAVARAM'
}